import { EntidadeBase } from 'hay-core-react';
class TermoUsoModel extends EntidadeBase {
    constructor() { super('termouso'); }
}

const instance = new TermoUsoModel();
export default instance;
